import * as React from 'react';
import { Link } from 'react-router-dom';

const Nav = (props) => (
  <nav className="navbar navbar-expand-md navbar-dark bg-dark">
      <Link className="navbar-brand" to="/">Star Wars</Link>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbar">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <Link className="nav-link" to="/">Home</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/planets">Planets</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/planets/add">Add Planet</Link>
          </li>
        </ul>
      </div>
    </nav>
);

export default Nav;